module.exports = __webpack_public_path__ + "img/img-recipient-man.f0ceb634.png";